<div class="registration-form__window">
  @if (!preregistrationComplete()) {
    <app-window>
      <span title>{{ 'features.preregister.title' | translate }}</span>
      <div body>
        @if (getUserStatus() === 'PENDING') {
          <p>{{ 'features.preregister.pending.description' | translate }}.</p>
        } @else if (getUserStatus() === 'ACCEPTED') {
          <p>{{ 'features.preregister.accepted.description' | translate }}.</p>
        } @else if (getUserStatus() === 'CONFIRMED') {
          <p>{{ 'features.preregister.confirmed.description' | translate }}.</p>
        } @else {
          <form class="registration-form" [formGroup]="registrationForm" (ngSubmit)="onSubmit()" novalidate>
            <!-- Tipo de ticket -->
            <div class="registration-form__field">
              <label for="ticketType" class="registration-form__label">
                {{ 'features.preregister.form.ticketType.label' | translate }}
                <span class="registration-form__required">*</span>
              </label>
              <select
                id="ticketType"
                class="registration-form__select"
                formControlName="ticketType"
                [class.registration-form__select--invalid]="isInvalid('ticketType')">
                <option value="">{{ 'features.preregister.form.ticketType.defaultOption' | translate }}</option>
                <option value="BRONZE">{{ 'features.preregister.form.ticketType.bronzeOption' | translate }} - 150€</option>
                <option value="SILVER">{{ 'features.preregister.form.ticketType.silverOption' | translate }} - 175€</option>
                <option value="GOLD">{{ 'features.preregister.form.ticketType.goldOption' | translate }} - 225€</option>
              </select>

              @if (isInvalid('ticketType')) {
                <div class="registration-form__error">{{ 'features.preregister.form.errors.invalidTicketType' | translate }}</div>
              }
            </div>

            <!-- ¿Vas a llevar fursuit? -->
            <div class="registration-form__field">
              <label class="registration-form__label">
                <input type="checkbox" class="registration-form__checkbox" formControlName="hasFursuit" />
                {{ 'features.preregister.form.hasFursuit' | translate }}
              </label>
            </div>

            <!-- ¿Quieres incluir la camiseta de preorder? -->
            <div class="registration-form__field">
              <label class="registration-form__label">
                <input type="checkbox" class="registration-form__checkbox" formControlName="wantsTshirt" />
                {{ 'features.preregister.form.hasPreorder' | translate }} - 20€
              </label>

              <button type="button" class="registration-form__link-button" (click)="onPreviewClick()">
                {{ 'features.preregister.form.checkPreview' | translate }}
                <span class="material-symbols-outlined">info</span>
              </button>
            </div>

            <!-- Talla de camiseta -->
            @if (showTshirtSize()) {
              <div class="registration-form__field">
                <label for="tshirtSize" class="registration-form__label">
                  {{ 'features.preregister.form.tshirtSize.label' | translate }}
                </label>
                <select id="tshirtSize" class="registration-form__select" formControlName="tshirtSize">
                  <option [ngValue]="null">{{ 'features.preregister.form.tshirtSize.defaultOption' | translate }}</option>
                  <option value="XS">XS</option>
                  <option value="S">S</option>
                  <option value="M">M</option>
                  <option value="L">L</option>
                  <option value="XL">XL</option>
                  <option value="2XL">2XL</option>
                  <option value="3XL">3XL</option>
                </select>
              </div>
            }

            <!-- Observaciones -->
            <div class="registration-form__field">
              <label for="notes" class="registration-form__label">{{ 'features.preregister.form.notes' | translate }}</label>
              <textarea
                id="notes"
                class="registration-form__textarea"
                formControlName="notes"
                [placeholder]="'features.preregister.form.placeholders.notes' | translate"></textarea>
            </div>

            <div class="registration-form__field">
              <label class="checkbox-label">
                <input class="registration-form__checkbox" type="checkbox" formControlName="acceptTerms" required />
                <span [innerHtml]="'features.preregister.form.checks.acceptTicketsTermsAndConditions' | translate"></span>
              </label>
            </div>

            <!-- Botón enviar -->
            <div class="registration-form__actions">
              <button
                type="submit"
                class="main-button"
                [disabled]="registrationForm.invalid"
                [attr.aria-disabled]="registrationForm.invalid">
                {{ 'features.preregister.form.button' | translate }}
              </button>
            </div>
          </form>
        }
      </div>
    </app-window>
  } @else {
    <!-- Mensaje de confirmación tras preregistro -->
    <app-window>
      <span title>{{ 'features.preregister.confirmationMessage.title' | translate }}</span>
      <div body>
        <p>{{ 'features.preregister.confirmationMessage.message.firstParagraph' | translate }}.</p>
        <p>{{ 'features.preregister.confirmationMessage.message.secondParagraph' | translate }}.</p>
      </div>
    </app-window>
  }
</div>

<!-- Modal con la preview de la camiseta -->
<div class="registration-form__preview">
  <app-modal [(open)]="previewOpen" [title]="'features.preregister.previewModal.title' | translate" [closeOnBackdropClick]="true">
    <img
      class="registration-form__image"
      src="resources/img/tshirt/exclusive-tshirt.png"
      [alt]="'features.preregister.previewModal.alt' | translate" />
  </app-modal>
</div>
